// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__gEtY_","popupContent":"Popup_popupContent__IdlCu","closePopupBtn":"Popup_closePopupBtn__Lx5Co"};